import styled from 'styled-components';

const StyledCarouselUl = styled.ul`
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
`;
const StyledCarouselLi = styled.li`
  bottom: 0;
  left: 0;
  list-style: none;
  overflow: hidden;
  padding-left: 0;
  position: absolute;
  right: 0;
  top: 0;
  &:before {
    content: none;
  }
`;

export { StyledCarouselUl, StyledCarouselLi };
